import MenuAddModal, { MenuAddModalReturnData } from 'features/MenuBook/components/MenuAddModal';
import { useState } from 'react';
import { Button } from 'react-bootstrap';
function MenuAddModalDemo() {
  const [is_show_modal, setShow] = useState(false);

  function handleClose() {
    setShow(false);
  }
  function handleShowModal() {
    setShow(true);
  }

  function onReflect(returnData: MenuAddModalReturnData) {
    setShow(false);
    console.log('selectedMenus', returnData.selectedMenus);
  }

  return (
    <>
      <Button onClick={handleShowModal}>MenuAddModalDemo </Button>
      <MenuAddModal
        isShowModal={is_show_modal}
        // subGenreId={1}
        // genreName={'genre name'}
        // subgenreName={'Subgenre name'}
        exceptMenuIds={[1, 2, 3]}
        dataDate={new Date()}
        onReflect={onReflect}
        onClose={handleClose}
      ></MenuAddModal>
    </>
  );
}

export default MenuAddModalDemo;
